import { getCalculatorProductsPrice } from '~/services/calculator.service'
import type {
    ICalculatorRawSetting,
    ICalculatorSelectedValues,
    ICalculatorSetting,
    ICalculatorSettingUpdaters,
    IFieldTitlesBySlug,
} from '~/types/calculator.types'

export const cabinCalculatorRawSetting: ICalculatorRawSetting = {
    fields: [
        {
            title: 'Количество кабин',
            slug: 'cabin_count',
            max_count: 20,
            default_disabled: false,
            default_hidden: false,
        },
    ],
    default_values: {
        cabin_count: 1,
        cabin_type: 'ec1',
        forced_ventilation: 'v1',
        case: 'c9000',
        transportation_bag: 'no-transport-bag',
    },
    fields_modal: [
        {
            type: 'counter',
            slug: 'cabin_count',
            prevent_hidden: false,
        },
        {
            type: 'select',
            slug: 'cabin_type',
            prevent_hidden: false,
        },
        {
            type: 'select',
            slug: 'forced_ventilation',
            prevent_hidden: false,
        },
        {
            type: 'select',
            slug: 'case',
            prevent_hidden: false,
        },
        {
            type: 'select',
            slug: 'transportation_bag',
            prevent_hidden: false,
        },
    ],
    fields_order: [
        'cabin_count',
        'cabin_type',
        'forced_ventilation',
        'case',
        'transportation_bag',
    ],
    images: [
        {
            counter_from: 'cabin_count',
            success_icon: false,
            hide_count: false,
            align: 'col',
            size: 'big',
            images: [
                {
                    image: '/assets/images/products/cabin/jpg-png/eurocab-3.png',
                    image_webp:
                        '/assets/images/products/cabin/webp/eurocab-3.webp',
                    values: {
                        cabin_type: 'ec3',
                    },
                },
                {
                    image: '/assets/images/products/cabin/jpg-png/eurocab-1.png',
                    image_webp:
                        '/assets/images/products/cabin/webp/eurocab-1.webp',
                    values: {
                        cabin_type: 'ec1',
                    },
                },
                {
                    image: '/assets/images/products/cabin/jpg-png/eurocab-11.png',
                    image_webp:
                        '/assets/images/products/cabin/webp/eurocab-11.webp',
                    values: {
                        cabin_type: 'ec11',
                    },
                },
            ],
        },
        {
            counter_from: '',
            success_icon: true,
            hide_count: false,
            align: 'row',
            size: 'small',
            images: [
                {
                    image: '/assets/images/products/ventilation/jpg-png/forced-ventilation.png',
                    image_webp:
                        '/assets/images/products/ventilation/webp/forced-ventilation.webp',
                    values: {
                        forced_ventilation: 'v1',
                    },
                },
            ],
        },
        {
            counter_from: '',
            success_icon: true,
            hide_count: false,
            align: 'row',
            size: 'small',
            images: [
                {
                    image: '/assets/images/products/case/jpg-png/cabin-case.png',
                    image_webp:
                        '/assets/images/products/case/webp/cabin-case.webp',
                    values: {
                        case: 'c9000',
                    },
                },
            ],
        },
        {
            counter_from: '',
            success_icon: true,
            hide_count: false,
            align: 'row',
            size: 'small',
            images: [
                {
                    image: '/assets/images/products/case/jpg-png/cabin-transportation-bag.png',
                    image_webp:
                        '/assets/images/products/case/webp/cabin-transportation-bag.webp',
                    values: {
                        transportation_bag: 'b2',
                    },
                },
            ],
        },
    ],
    price_modificators: {},
    prices: {},
}

export const cabinFieldTitles: IFieldTitlesBySlug = {
    cabin_type: 'Тип кабины',
    forced_ventilation: 'Вентиляция принудительная',
    case: 'Кейс',
    transportation_bag: 'Транспортировочная сумка',
}

export const cabinUpdaters: ICalculatorSettingUpdaters = {
    cabin_type: updateCabinCabinType,
}

function updateCabinCabinType(
    selectedValues: ICalculatorSelectedValues
): [string, string | number, boolean, boolean][] {
    return [
        [
            'forced_ventilation',
            selectedValues.cabin_type === 'ec3'
                ? 'no-forced-ventilation'
                : 'v1',
            false,
            selectedValues.cabin_type === 'ec3',
        ],
        [
            'case',
            selectedValues.cabin_type === 'ec3' ? 'no-case' : 'c9000',
            false,
            selectedValues.cabin_type === 'ec3',
        ],
        [
            'transportation_bag',
            selectedValues.cabin_type !== 'ec3' ? 'no-transport-bag' : 'b2',
            false,
            selectedValues.cabin_type !== 'ec3',
        ],
    ]
}

export function cabinGetPrice(
    calculator: ICalculatorSetting,
    selectedValues: ICalculatorSelectedValues
): string {
    const productPrices: { [key: string]: number } = getCalculatorProductsPrice(
        calculator,
        selectedValues
    )

    const forcedVentilationPrice =
        productPrices['forced_ventilation'] *
        (selectedValues['cabin_type'] === 'ec1' ? 2 : 1)

    const price: number =
        Number(selectedValues.cabin_count) *
        (productPrices['cabin_type'] +
            forcedVentilationPrice +
            productPrices['case'] +
            productPrices['transportation_bag'])

    return formatPrice(price)
}
